<style>

h1 {
    margin-bottom: 10px;
}

h3 {
    margin-bottom: 0px;
}


:global(.new-controls) {
    margin-top: 10px;
    width: 100%;
}

:global(.control) {
    color: grey;
    border:1px solid rgb(223, 223, 223);
    border-radius: 15px;
    font-size: 14px;
    display: inline-flex;
    flex-direction: row;
    line-height: 1em;
    overflow: hidden;
    cursor: pointer;
}

:global(.control-number) {
    padding: 8px;
    border-right: 1px solid rgb(223, 223, 223);
}

:global(.control-button) {
    padding: 8px;
}

:global(.control-single) {
	background-color: white;
	color: grey;
	border: 1px solid rgb(223, 223, 223);
    font-size: 14px;
    line-height: 1em;
    display: inline-block;
    padding: 8px;
    border-radius: 15px !important;
    cursor: pointer;
}

:global(.control-single:hover) {
	background-color: #ebebf3 !important;
}

:global(.control-button:hover) {
	background-color: #ebebf3 !important;
}

/*Municipal*/
.badge {
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    background-color: rgb(123, 123, 123);
}

.official-tagline {
    color: grey;
    font-size: 12px;
    margin-left: 10px;
}

.rich-content-holder {
    margin-top: 15px;
    margin-bottom: 15px;
}

.tags-holder {
    padding-top: 10px;
    padding-bottom: 10px;
}

.tag {
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
    background-color: rgb(235, 235, 243);
    color: grey;
    margin: 5px;
    margin-right: 10px;
    margin-left: 0px;
    display: inline-block;
    cursor: pointer;
}

.tag:hover {
    background-color: rgb(70, 70, 70);
    color: white;
}

</style>

<script>
import {push} from './pt-router/Router.svelte'
import {onMount, afterUpdate} from 'svelte'
import FeedView from './FeedView.svelte'
import * as Common from './Common.js'
import Spinner from './Spinner.svelte'

import { getContext } from 'svelte';
const { open } = getContext('simple-modal');
import ShareSheetModal from './Sharing/ShareSheetModal.svelte'

export let area;
export let side

let feed = []
let inProgress = false
let latestTimestamp = Math.floor(Date.now() / 1000)

let scrollTopId = null
let scrollTopValue = null

$: area && refereshRecentCommentsAndItems()
$: area && refreshRecentTags()
let oldAreaId = -1

let recentTags = []

afterUpdate(() => {
    if(scrollTopId) {
        let elem = document.getElementById(scrollTopId)
        if(elem) {
            elem.scrollIntoView()
            side.scrollTop = scrollTopValue
            scrollTopId = null
        }
    }
})

function refreshRecentTags() {
    Common.getData('tags?area_id=' +area.id)
    .then(data => {
        recentTags = data
    })
}

function refereshRecentCommentsAndItems() {
    if(area.id==oldAreaId) {
        return
    }
    oldAreaId=area.id
    feed = []
    latestTimestamp = Math.floor(Date.now() / 1000)
    console.log("refereshRecentCommentsAndItems()", area)
    let cachedFeedInfo = Common.getCachedFeed("area"+area.id)
    if(cachedFeedInfo) {
        let info = JSON.parse(cachedFeedInfo)
        feed = info.feed
        latestTimestamp = feed[feed.length-1].data.createtime
        scrollTopId = info.itemId
        scrollTopValue = info.scrollTopValue
        Common.clearCachedFeed("area"+area.id)
    } else {
        console.log("inProgress:", inProgress)
        requestNextFeedItems()
    }

    let parentevent = side.onscroll
    side.onscroll = () => {
        parentevent()
        if((side.scrollHeight - (side.scrollTop + side.clientHeight)) < 800) {
            requestNextFeedItems()
        }
    }
}

function requestNextFeedItems() {
    console.log("requestNextFeedItems()")
    if(inProgress) {
        return
    }
    inProgress = true
    
    Common.getData('area/' + area.id + '/recent?seen=' + latestTimestamp)
    .then(data => {
        feed = feed.concat(data)
        if(feed.length==0) {
            inProgress = false
            return
        }
        latestTimestamp = feed[feed.length-1].data.createtime
        inProgress = false
    })
}


function goPro() {
    push('/tools/incoming')
}

function showEmailSubscribeDialog() {
    let req
    if(!Common.currentUserValue) {
        let res = window.prompt("Enter your Email to receive regular updates for " + area.name + ":","");
        if(res.length === 0 || !Common.isValidEmail(res)) {
            alert("Invalid Email.")
            return
        }
        req = {
            area_id: area.id,
            email: res
        }
    } else {
        req = {
            area_id: area.id,
            email: Common.currentUserValue.user_email
        }
    }
    Common.postData("subscribe", req)
    .then(r => {
        if(!r.ok) {
            alert("Problem subscribing, please try again!");
            return
        }
        Common.CreateNotification({body: "Thanks! We'll keep you up to date!"}, 1000)
    })
}

function showShareSheet() {
    open(ShareSheetModal, {
        link: "https://plantogether.city/area/" + area.id,
        shareString: area.name + ", " + area.country + " on Plan Together"},
        {content: { fontSize: '14px', lineHeight: '1.5em'}});
}

</script>

<svelte:head>
    <!-- Primary Meta Tags -->
    <title>{area.name + ", " + area.country + " on Plan Together"}</title>
    <meta name="title" content={area.name + ", " + area.country + " on Plan Together"}>
    <meta name="description" content={"Discuss, Plan and Learn about " + area.name + " on a Dynamic, Collaborative Map."}>

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" content={"https://plantogether.city/area/" + area.id}>
    <meta property="og:title" content={area.name + ", " + area.country + " on Plan Together"}>
    <meta property="og:description" content={"Discuss, Plan and Learn about " + area.name + " on a Dynamic, Collaborative Map."}>
    <meta property="og:image" content={"API_URL/area-image/" + area.id + ".png"}>

    <!-- Twitter -->
    <meta property="twitter:card" content="summary_large_image">
    <meta property="twitter:url" content={"https://plantogether.city/area/" + area.id}>
    <meta property="twitter:title" content={area.name + ", " + area.country + " on Plan Together"}>
    <meta property="twitter:description" content={"Discuss, Plan and Learn about " + area.name + " on a Dynamic, Collaborative Map."}>
    <meta property="twitter:image" content={"API_URL/area-image/" + area.id + ".png"}>
</svelte:head>


<div class="top">
    {#if area.verified}
        <div>
            <span class="badge">Official Area</span> <i class="official-tagline">Municipal Employees are Present and Active</i>
        </div>
    {/if}

    <h1>{area.name}, {area.country}</h1>
    <p class="rich-content-holder">
        {@html Common.sanitizeContent(area.information)}
    </p>
    <div class="new-controls">
        <div class="control-single" on:click={showEmailSubscribeDialog}>Get Email Updates</div>
        <div class="control-single" on:click={showShareSheet}>Share</div>
        <div class="control-single" on:click={goPro}>Municipal Tools</div>
    </div>

    <h3>Top Tags</h3>
    <div class="tags-holder">
        {#each recentTags as tag}
            <div class="tag" on:click={()=> push('/tag/'+tag + '?area_id=' + area.id)}># {tag}</div>
        {/each}
    </div>
    <h3>Recent</h3>
</div>

{#if !inProgress && feed.length === 0}
<div>
    <p>
        Looks like you are the very first one here! You have two options:
    </p>
    <ul>
        {#if Common.currentUserValue}
            <li><a href="#/add-item/0">Start the Conversation and Add to the Map</a></li>
        {:else}
            <li><a href="#/login">Sign Up and Add to the Map</a></li>
        {/if}
        <li><a href="#/area/1">Check Out This Area for Inspiration</a></li>
    </ul>
</div>
{:else}
    <FeedView includeNames={true} displayAreaLabels={false} {feed} feedName={"area"+area.id} {side}></FeedView>
    {#if inProgress}
        <Spinner></Spinner>
    {/if}
{/if}
